import { lazy } from 'react';
import { centerModalOption } from '../../../appComponents/ModalWrapper';
import { wrapNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const CategoriesConfirmPageContentWrapper = lazy(
  () => import('./CategoriesConfirmPageContent'),
);

const CategoriesConfirmPage = wrapNavigatorScreen(
  CategoriesConfirmPageContentWrapper,
  centerModalOption,
);

export default CategoriesConfirmPage;
